import React, { useEffect } from "react";

const KitForm = () => {


      return (
            <div>
                  <script src="https://f.convertkit.com/ckjs/ck.5.js"></script>
                  <form action="https://app.kit.com/forms/7879226/subscriptions"
                        class="seva-form formkit-form"
                        method="post"
                        data-sv-form="7879226"
                        data-uid="c09dbebbfc"
                        data-format="inline"
                        data-version="5"
                        data-options="{&quot;settings&quot;:{&quot;after_subscribe&quot;:{&quot;action&quot;:&quot;message&quot;,&quot;success_message&quot;:&quot;Success! Now check your email to confirm your subscription.&quot;,&quot;redirect_url&quot;:&quot;&quot;},&quot;analytics&quot;:{&quot;google&quot;:null,&quot;fathom&quot;:null,&quot;facebook&quot;:null,&quot;segment&quot;:null,&quot;pinterest&quot;:null,&quot;sparkloop&quot;:null,&quot;googletagmanager&quot;:null},&quot;modal&quot;:{&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;powered_by&quot;:{&quot;show&quot;:true,&quot;url&quot;:&quot;https://kit.com/features/forms?utm_campaign=poweredby&amp;utm_content=form&amp;utm_medium=referral&amp;utm_source=dynamic&quot;},&quot;recaptcha&quot;:{&quot;enabled&quot;:false},&quot;return_visitor&quot;:{&quot;action&quot;:&quot;show&quot;,&quot;custom_content&quot;:&quot;&quot;},&quot;slide_in&quot;:{&quot;display_in&quot;:&quot;bottom_right&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;sticky_bar&quot;:{&quot;display_in&quot;:&quot;top&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15}},&quot;version&quot;:&quot;5&quot;}"
                        min-width="400 500 600 700 800"
                  >
                        <div class="formkit-background" ></div>
                        <div data-style="minimal">
                              <div class="formkit-header" data-element="header" >
                                    <h2>Join the Newsletter</h2>
                              </div>
                              <div class="formkit-subheader" data-element="subheader" >Subscribe to get our latest content by email.</div>
                              <ul class="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul>
                              <div data-element="fields" data-stacked="false" class="seva-fields formkit-fields">
                                    <div class="formkit-field">
                                          <input className="input is-small" name="email_address" aria-label="Email Address" placeholder="Email Address" required="" type="email" />
                                    </div>
                                    <button data-element="submit" className="button is-dark is-small" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                          <div class="formkit-spinner">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                          </div>
                                          <span class="">Subscribe</span>
                                    </button>
                              </div>
                              <div class="formkit-guarantee" data-element="guarantee" >We won't send you spam. Unsubscribe at any time.</div>
                              <div class="formkit-powered-by-convertkit-container">

                              </div>
                        </div>
                  </form>
                  
            </div>
            
      );
};

export default KitForm;
